/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Per_Unit_PersonInputs */

const en_admin_resource_form_per_unit_person = /** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per person`)
};

const de_admin_resource_form_per_unit_person = /** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Person`)
};

const es_admin_resource_form_per_unit_person = /** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por persona`)
};

const fr_admin_resource_form_per_unit_person = /** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par personne`)
};

const nl_admin_resource_form_per_unit_person = /** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per persoon`)
};

/** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */
const it_admin_resource_form_per_unit_person = en_admin_resource_form_per_unit_person;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */
const pt_br2_admin_resource_form_per_unit_person = en_admin_resource_form_per_unit_person;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */
const pl_admin_resource_form_per_unit_person = en_admin_resource_form_per_unit_person;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */
const hu_admin_resource_form_per_unit_person = en_admin_resource_form_per_unit_person;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_PersonInputs) => LocalizedString} */
const ro_admin_resource_form_per_unit_person = en_admin_resource_form_per_unit_person;

/**
* | output |
* | --- |
* | "per person" |
*
* @param {Admin_Resource_Form_Per_Unit_PersonInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_per_unit_person = /** @type {((inputs?: Admin_Resource_Form_Per_Unit_PersonInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Per_Unit_PersonInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_per_unit_person(inputs)
	if (locale === "de") return de_admin_resource_form_per_unit_person(inputs)
	if (locale === "es") return es_admin_resource_form_per_unit_person(inputs)
	if (locale === "fr") return fr_admin_resource_form_per_unit_person(inputs)
	if (locale === "nl") return nl_admin_resource_form_per_unit_person(inputs)
	if (locale === "it") return it_admin_resource_form_per_unit_person(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_per_unit_person(inputs)
	if (locale === "pl") return pl_admin_resource_form_per_unit_person(inputs)
	if (locale === "hu") return hu_admin_resource_form_per_unit_person(inputs)
	return ro_admin_resource_form_per_unit_person(inputs)
});
export { admin_resource_form_per_unit_person as "admin.resource_form.per_unit_person" }